import React from 'react';
import icon from '../../Assets/img/info-icon.png';

function InfoToast({ destination }) {
    return (
        <div>
            <div className="icon-text-container">
                <img src={icon} alt="info" className="warning-icon" />
                <span>
                    {destination === 'progress' ? 'Your request is in progress, please wait...' : `Verification Code Sent to ${destination}`}
                </span>
            </div>
        </div>
    );
}

export default InfoToast;
